(function () {
  'use strict';

  const CartBar = {
    bar: null,
    lastCount: null,
    lastTotal: null,
    observer: null,
    updating: false,

    init() {
      this.bar = document.getElementById('cart-summary-bar');
      if (!this.bar) return;

      this.updateCart();
      this.observeCartChanges();

      console.log('✅ Cart Summary Bar initialized');
    },

    /* =============================
       OBSERVE CART DOM (KEY FIX)
       ============================= */
    observeCartChanges() {
      const target = document.body;

      this.observer = new MutationObserver(() => {
        this.debouncedUpdate();
      });

      this.observer.observe(target, {
        childList: true,
        subtree: true
      });
    },

    debouncedUpdate() {
      if (this.updating) return;

      this.updating = true;

      setTimeout(() => {
        this.updateCart();
        this.updating = false;
      }, 500); // wait until Shopify finishes updating
    },

    async updateCart() {
      try {
        const res = await fetch('/cart.js?ts=' + Date.now(), {
          cache: 'no-store'
        });
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('❌ Cart fetch failed', err);
      }
    },

    render(cart) {
      if (!cart || !this.bar) return;

      const count = cart.item_count;
      const total = cart.total_price;

      if (count === this.lastCount && total === this.lastTotal) return;

      this.lastCount = count;
      this.lastTotal = total;

      /* VISIBILITY */
      if (count > 0) {
        this.bar.classList.remove('cart-summary-bar--hidden');
        this.bar.classList.add('cart-summary-bar--visible');
      } else {
        this.bar.classList.remove('cart-summary-bar--visible');
        this.bar.classList.add('cart-summary-bar--hidden');
      }

      /* TEXT */
      const title = this.bar.querySelector('.cart-summary-bar__title');
      const subtotal = this.bar.querySelector('.cart-summary-bar__subtotal');

      if (title) {
        title.textContent = count > 0 ? 'Your cart' : 'Your cart is empty';
      }

      if (subtotal) {
        subtotal.textContent = this.formatMoney(total);
      }

      console.log('🛒 Cart updated:', count, total);
    },

    formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(
          cents,
          window.money_format || '{{ shop.money_format }}'
        );
      }

      return (cents / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR'
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => CartBar.init());
  window.forceCartUpdate = () => CartBar.updateCart();
})();
